import React from "react";
import { GoogleMap } from "@react-google-maps/api";
import { Circle } from "../../../../theme/maps";
import ICoverageArea from "../../interfaces/ICoverageArea";
import { colors } from "../../../ui/colors";
import { useMediaQuery, useTheme } from "@mui/material";

interface Props {
  areas: ICoverageArea[] | ICoverageArea;
  center: { lat: number; lng: number };
}

export const MapCoverage: React.FC<Props> = ({ areas, center }) => {
  const mapRef = React.useRef<google.maps.Map | null>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const areasList = React.useMemo(() => {
    if (!areas) return [];
    return Array.isArray(areas) ? areas : [areas];
  }, [areas]);

  React.useEffect(() => {
    if (mapRef.current && center) {
      google.maps.event.trigger(mapRef.current, "resize");
      mapRef.current.panTo(center);
    }
  }, [center]);

  return (
    <GoogleMap
      mapContainerStyle={{ width: "100%", height: "100%" }}
      center={center}
      zoom={isMobile ? 9 : 11}
      onLoad={(map) => {
        mapRef.current = map;
      }}
      options={{
        disableDefaultUI: true,
        zoomControl: true,
      }}
    >
      {areasList.map((area, idx) => {
        if (typeof area.latitude !== "number" || !area.milesOfCoverageArea) {
          return null;
        }

        return (
          <Circle
            key={area.id || `area-${idx}`}
            center={{ lat: area.latitude, lng: area.longitude }}
            radius={Number(area.milesOfCoverageArea) * 1609.34}
            options={{
              strokeColor: area.color || colors.orange.base,
              fillColor: area.color || colors.orange.base,
              fillOpacity: 0.35,
              strokeWeight: 2,
              clickable: false,
              editable: false,
              zIndex: 1000,
            }}
          />
        );
      })}
    </GoogleMap>
  );
};

export default MapCoverage;
